var StatusEditController = (function () {
    function StatusEditController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, admin, $timeout, Dialog, $q, settings) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.admin = admin;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$q = $q;
        this.settings = settings;
        this.mainStatus = {};
        this.approvalStage = false;
        this.editMode = false;
        this.id = '';
        this.original = { _id: '' }; //for future logging reference at save time
        this.select = {
            users: {}
        };
        this.newStage = false;
        this.stageOwners = [];
        this.handOffActivity = [];
        this.handOffRoles = [];
        this.mysaStatuses = [];
        this.dswEligibilityAppStatusArray = [];
        this.approvers = { bpso: [], nonbpso: [] };
        this.selectValid = false;
        this.loaded = { bpso: false, nonbpso: false, statuses: false };
        this.readyMan = false;
        this.events = { beingSaved: false, beingDeleted: false };
        this.conflicts = { title: '', notManagers: [], viewDetails: false, resolved: true };
        this.serverError = null;
        this.filter = 'Active'; // Default
        this.rolesLoaded = false;
        this.statusesLoaded = false;
        this.dswStatusesLoaded = false;
        this.id = $stateParams.status;
        this.disInStatus = { opps: [], viewDetails: false };
        this.pwWithStatus = { pws: [], viewDetails: false };
        this.stageOwners = ['BPSO', 'Business Partner', 'Billing', 'Channels', 'Vendor', 'Brand', 'Other IBM Function', 'SPM'];
        this.handOffActivity = ['No ES Hand Off', 'Create ES Hand Off', 'Close ES Request'];
        //Listener for bpso and non bpso admin users
        //TO DO
        this.socket.forward('approvals.usersbyrole', this.$scope);
        this.$scope.$on('socket:approvals.usersbyrole', function (event, data) {
            //  this.$timeout(() => {
            //this.setProgramData(data);
            if (data.role === 2) {
                _this.approvers.bpso = data.results;
                _this.loaded.bpso = true;
            }
            else if (data.role === 3) {
                _this.approvers.nonbpso = data.results;
                _this.loaded.nonbpso = true;
            }
            _this.checkAllLoaded();
            //  }, 1000); //hmm..naughty
        });
        this.socket.forward('engage_support.roles', this.$scope);
        this.$scope.$on('socket:engage_support.roles', function (event, data) {
            _this.handOffRoles = data.roles;
            _this.rolesLoaded = true;
        });
        this.socket.forward('mysaStatuses.list', this.$scope);
        this.$scope.$on('socket:mysaStatuses.list', function (event, data) {
            _this.mysaStatuses = data.statuses;
            _this.statusesLoaded = true;
        });
        this.socket.forward('dswStatuses.list', this.$scope);
        this.$scope.$on('socket:dswStatuses.list', function (event, data) {
            _this.dswEligibilityAppStatusArray = data.statuses;
            _this.dswStatusesLoaded = true;
        });
        //Listen out for a broadcast from the site.body for when the config statuses are loaded...
        // this will only be required if accessing the url directly
        //  $scope.$on('configStatusLoaded', (events, args) => {
        this.setUp(); //Then run the set-up
        //  });
    }
    StatusEditController.prototype.selectAll = function (tf) {
        var _this = this;
        if (!tf) {
            this.select.users = {};
        }
        else {
            angular.forEach(this.approvers[this.approvalGroup], function (x) {
                _this.select.users[x.email] = true;
            });
        }
        this.syncApprovers();
    };
    StatusEditController.prototype.setBGName = function () {
        if (this.editing.bpso && this.editing.peer) {
            this.bgName = 'DMT BPSO Administrators';
        }
        else if (!this.editing.bpso && this.editing.peer) {
            this.bgName = 'DMT Non-BPSO Administrators';
        }
        else if (this.editing.bpso && !this.editing.peer) {
            this.bgName = 'DMT BPSO Approvers';
        }
        else if (!this.editing.bpso && !this.editing.peer) {
            this.bgName = 'DMT Non-BPSO Approvers';
        }
    };
    StatusEditController.prototype.removeNonManagers = function () {
        var _this = this;
        angular.forEach(this.conflicts.notManagers, function (x) {
            _this.select.users[x.email] = false;
        });
        this.conflicts.resolved = true;
        this.syncApprovers();
    };
    StatusEditController.prototype.syncApprovers = function () {
        var _this = this;
        if (this.editing.peer) {
            this.selectValid = true;
            return;
        }
        var newApprovers = [];
        //Based on what has been selected in the select.users array, loop through and update the editing.users
        // accordingly
        angular.forEach(this.select.users, function (value, key) {
            if (value) {
                //find the matching object in the approvers list
                _this.approvers[_this.approvalGroup].some(function (approver) {
                    if (approver.email === key) {
                        newApprovers.push(approver); //Add to array
                        //let tempApp = angular.copy(approver);
                        //delete tempApp.is_manager;
                        //newApprovers.push(tempApp); //Add to array
                        return true; //break
                    }
                });
            }
        });
        this.editing.users = newApprovers;
        if (this.editing.users.length > 0) {
            this.selectValid = true;
        }
        else {
            this.selectValid = false;
        }
    };
    StatusEditController.prototype.checkAllLoaded = function () {
        //If an Approval stage, gonna need both bpso and non-bpso approvers and the statuses
        if ([2, 4].indexOf(Number(this.id)) > -1) {
            if (this.loaded.bpso && this.loaded.nonbpso && this.loaded.statuses && this.rolesLoaded && this.statusesLoaded && this.dswStatusesLoaded) {
                this.readyMan = true;
            }
        }
        else {
            if (this.loaded.statuses && this.rolesLoaded && this.statusesLoaded && this.dswStatusesLoaded) {
                this.readyMan = true;
            }
        }
    };
    StatusEditController.prototype.createNew = function () {
        //First work out what the next number in sequence will be
        var nextNumber = 0;
        if (this.mainStatus && Array.isArray(this.mainStatus.subs)) {
            nextNumber = Math.max.apply(Math, this.mainStatus.subs.map(function (s) { return s.no; }).concat([nextNumber]));
        }
        nextNumber++; //roll it on
        this.editing = {
            active: true,
            dswEligibilityApp: false,
            prmOutbound: false,
            duplicateCheck: false,
            esHandOff: this.handOffActivity[0],
            esHandOffRole: this.handOffRoles[0].roleId,
            mySAPortalStatus: this.mysaStatuses[0],
            dswEligibilityAppStatus: this.dswEligibilityAppStatusArray[0],
            no: nextNumber,
            owner: 'BPSO',
            system: false
        };
        if (this.approvalStage) {
            this.editing.bpso = true;
            this.editing.clip = 0;
            this.editing.manager = false;
            this.editing.peer = true;
        }
        this.setBGName();
        this.newStage = true;
        this.selectValid = true;
        this.editMode = true;
    };
    StatusEditController.prototype.refresh = function () {
        var _this = this;
        if (this.approvalStage) {
            if (this.editing.peer) {
                delete this.editing.users;
                this.selectValid = true;
            }
            else {
                if (!this.editing.users) {
                    this.editing.users = [];
                }
                if (this.editing.bpso) {
                    this.approvalGroup = 'bpso';
                }
                else {
                    this.approvalGroup = 'nonbpso';
                }
                //loop though the exiting editing users to create
                angular.forEach(this.editing.users, function (approver) {
                    _this.select.users[approver.email] = true;
                });
                this.syncApprovers();
            }
            this.setBGName();
        }
        else {
            //Non approval stage
            this.selectValid = true;
        }
    };
    StatusEditController.prototype.reset = function (mainStatus) {
        var _this = this;
        angular.forEach(this.mainStatus.subs, function (sub) {
            if (mainStatus === sub.no) {
                _this.editing = angular.copy(sub);
            }
        });
    };
    StatusEditController.prototype.updateConfig = function () {
        var _this = this;
        //Find the status to update, change it
        var index = 0;
        //this.config.tempData.rows.forEach((main) => {
        this.settings.status_cfg.forEach(function (main) {
            if (main.no === _this.mainStatus.no) {
                if (!_this.newStage) {
                    //If not new, find it and replace it
                    main.subs.forEach(function (subby) {
                        if (subby.no === _this.editing.no) {
                            main.subs.splice(index, 1, _this.editing);
                        }
                        index++;
                    });
                }
                else {
                    main.subs.push(_this.editing);
                    _this.newStage = false; // reset
                }
            }
        });
    };
    StatusEditController.prototype.setEditingData = function (mainStatus) {
        var _this = this;
        angular.forEach(this.mainStatus.subs, function (sub) {
            if (mainStatus === sub.no) {
                _this.editing = angular.copy(sub);
                _this.refresh();
                _this.editMode = true;
                //If no system value, set as false
                _this.editing.system = !_this.editing.system ? false : _this.editing.system;
                // If no active value, set as true
                _this.editing.active = angular.isUndefined(_this.editing.active) ? true : _this.editing.active;
                // // If no value for esHandOff, set as false
                _this.editing.esHandOff = angular.isUndefined(_this.editing.esHandOff) ? _this.handOffActivity[0] : _this.editing.esHandOff;
                _this.editing.esHandOffRole = angular.isUndefined(_this.editing.esHandOffRole) ? _this.handOffRoles[0].roleId : _this.editing.esHandOffRole;
                _this.editing.mySAPortalStatus = angular.isUndefined(_this.editing.mySAPortalStatus) ? _this.mysaStatuses[0] : _this.editing.mySAPortalStatus;
                _this.editing.duplicateCheck = angular.isUndefined(_this.editing.duplicateCheck) ? false : _this.editing.duplicateCheck;
                _this.editing.dswEligibilityApp = !!_this.editing.dswEligibilityApp;
                _this.editing.prmOutbound = !!_this.editing.prmOutbound;
                _this.editing.dswEligibilityAppStatus = angular.isUndefined(_this.editing.dswEligibilityAppStatus) ? _this.dswEligibilityAppStatusArray[0] : _this.editing.dswEligibilityAppStatus;
            }
        });
    };
    StatusEditController.prototype.cancel = function (event) {
        this.reset(this.mainStatus.no);
        this.$scope.statForm.$setPristine();
        this.select = { users: {} };
        this.serverError = null;
        this.newStage = false;
        this.conflicts = { title: '', notManagers: [], resolved: true };
        this.disInStatus = { opps: [], viewDetails: false };
        this.pwWithStatus = { pws: [], viewDetails: false };
        this.editMode = false;
    };
    /**
     * notManagers - Function to check if the users listed as approvers are actually managers if the isManager field
     * is set...if not, return array of those that are not managers
     *
     * @return {type}  description
     */
    StatusEditController.prototype.notManagers = function () {
        var _this = this;
        this.conflicts.notManagers = [];
        if (this.editing.manager) {
            angular.forEach(this.editing.users, function (user) {
                angular.forEach(_this.approvers[_this.approvalGroup], function (approver) {
                    if (user.email === approver.email && approver.is_manager !== 'Y') {
                        _this.conflicts.notManagers.push(user);
                    }
                });
            });
        }
        if (this.conflicts.notManagers.length > 0) {
            this.conflicts.resolved = false;
            return true;
        }
        else {
            return false;
        }
    };
    StatusEditController.prototype.isConflict = function () {
        var _this = this;
        this.mainStatus.subs.some(function (sub) {
            if (sub.no !== _this.editing.no && angular.equals(sub.txt.toUpperCase(), _this.editing.txt.toUpperCase())) {
                _this.conflicts.title = sub.txt.toUpperCase();
                return true; //break
            }
        });
        if (this.conflicts.title) {
            return true;
        }
        else {
            this.conflicts.title = '';
            return false;
        }
    };
    /**
     * save - Function triggered when user clicks the Save button.
     *
     * @param  {type} event: any Browser event for the benefit of the display prompts (if needed)
     */
    StatusEditController.prototype.save = function (event) {
        var _this = this;
        //Ensure the name is not already taken inside this status...can have dupes in other statuses
        if (this.isConflict()) {
            return;
        }
        //Ensure managers are managers if they're all meant to be
        if (this.notManagers()) {
            return;
        }
        //if saving an update to an existing one, loop through the mainstatus.values and replace the entire object
        // - also make a note of whether the txt has changed...if so, will mean a db2 update, too
        var index = 0;
        var titleChange = false;
        var deactivate = false;
        var statusToSave = angular.copy(this.mainStatus); //move this to server-side
        angular.forEach(this.mainStatus.subs, function (sub) {
            if (sub.no === _this.editing.no) {
                //replace it
                statusToSave.subs.splice(index, 1, _this.editing); //move this to server-side
                //Check title...if it's change set db2 flag
                if (sub.txt !== _this.editing.txt) {
                    titleChange = true;
                }
                // Check if active status is being deactivated
                if ((sub.active === true || angular.isUndefined(sub.active)) && !_this.editing.active) {
                    deactivate = true;
                }
            }
            index++;
        });
        // If a MySA value is there, ensure it's in uppercase
        if (angular.isDefined(this.editing.mysa) && this.editing.mysa.trim() !== '') {
            this.editing.mysa = this.editing.mysa.toUpperCase();
        }
        else {
            delete this.editing.mysa;
        }
        var saveBundle = {
            msDesc: this.mainStatus.txt,
            msNo: this.mainStatus.no,
            status: this.editing,
            newStage: this.newStage,
            title: titleChange,
            deactivated: deactivate
        };
        // console.log('send this', saveBundle);
        //return;
        this.events.beingSaved = true; //set flag to disable save button
        this.serverError = null;
        //Make the call via a promise which will wait up to 30 seconds for a response
        this.savePromise(saveBundle).then(function (data) {
            //If response from server received
            _this.events.beingSaved = false; //enable save again
            // If there's an error
            if (data.error) {
                _this.serverError = data.error;
                if (data.error.indexOf('Disbursements in this status') > -1) {
                    _this.disInStatus.opps = data.opps; // Add the Disbursements 
                }
                else if (data.error.indexOf('There are Program Workflows') > -1) {
                    _this.pwWithStatus.pws = data.flows; // Add the Workflows 
                }
            }
            else {
                _this.updateConfig();
                _this.reset(_this.mainStatus.no); //Otherwise edit details remain if user goes to another stage
                _this.$scope.statForm.$setPristine(); //May not be necessary
                _this.editMode = false; //out of edit mode and back to sub-status view
            }
        }, function (nothingReturnedInTime) {
            //If no response from server received
            _this.events.beingSaved = false; //enable save again
            _this.serverError = 'The server does not appear to be responding, or did not respond in a reasonable time.';
        });
    };
    StatusEditController.prototype.setUp = function () {
        var _this = this;
        //If the config is loaded and readyMan var not set...
        //if (this.config.tempData.rows && !this.readyMan) {
        if (this.settings.status_cfg && !this.readyMan) {
            this.readyMan = true;
            this.loaded.statuses = true;
            //this.config.tempData.rows.some((row) => {
            this.settings.status_cfg.some(function (main) {
                if (main.no === Number(_this.id)) {
                    _this.mainStatus = main;
                    return true; //break loop
                }
            });
            if (this.mainStatus.no === 2 || this.mainStatus.no === 5) {
                this.approvalStage = true;
            }
            this.checkAllLoaded();
        }
    };
    StatusEditController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getHandOffRoles',
                script: '/engage-support/roles/extractESRoles',
                user: this.env.user
            }
        });
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getMySAPortalStatuses',
                script: '/mysaStatuses/index',
                user: this.env.user
            }
        });
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getDSWEligAppStatuses',
                script: '/dswEligibilityAppStatuses/index',
                user: this.env.user
            }
        });
        //If moving from the Status View then the configs will already be loaded...
        if (this.config.statusesLoaded) {
            //if so...call the set-up
            this.setUp();
        }
        if ([2, 5].indexOf(Number(this.id)) > -1) {
            if (!this.loaded.bpso) {
                //TO DO
                this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getUsersByRoleApprovals',
                        roleNumber: 2,
                        script: '/approvals/approvals',
                        user: this.env.user
                    }
                });
            }
            if (!this.loaded.nonbpso) {
                //TO DO
                this.socket.emit('module', {
                    module: {
                        application: 'dmt',
                        function: 'getUsersByRoleApprovals',
                        roleNumber: 3,
                        script: '/approvals/approvals',
                        user: this.env.user
                    }
                });
            }
        }
    };
    StatusEditController.prototype.displayPrompt = function (event, bundle, icon) {
        var items = {
            title: bundle.title,
            message: bundle.textContent,
            icon: icon //ERROR, INFO, WARN
        };
        this.Dialog.openDialog(event, items, DialogService, 'confirm-prompt.html');
    };
    StatusEditController.prototype.savePromise = function (saveBundle) {
        var _this = this;
        this.deferred = this.$q.defer(); //Set deferred object...to be sent to browser
        this.$timeout(function () {
            _this.deferred.reject([]); //If not resolved within 3 seconds...reject
        }, 30000); //30 secs
        this.config.updateStatusConfig(saveBundle);
        // TO DO
        this.socket.forward('config.config_update', this.$scope);
        this.$scope.$on('socket:config.config_update', function (event, data) {
            _this.deferred.resolve(data); //add the results to the deferred object
        });
        return this.deferred.promise; //fire off the promise
    };
    StatusEditController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket', '$scope', 'config', 'admin', '$timeout', 'Dialog', '$q', 'settings'];
    return StatusEditController;
}());
var StatusEditComponent = (function () {
    function StatusEditComponent() {
        this.templateUrl = 'status.html';
        this.controllerAs = 'vm';
        this.controller = StatusEditController;
    }
    return StatusEditComponent;
}());
angular
    .module('application')
    .component('adminStatusSection', new StatusEditComponent());

//# sourceMappingURL=status.edit.component.js.map
